import React from "react";
import Modal from '../../../components/Modal';
import {useWindowWidth} from "../../../hooks";
import Table from '../../../components/Table';
import {saveFileBlob} from "../../../utils";
import {ButtonPrimary} from "../../../components/base/BaseButton";

export default ({
    show,
    onClose,
    maxWidth = 700,
    data = []
}) => {

    const resizedWidth = useWindowWidth();

    const columns = [
        {
            id: 'name',
            label: "Name",
            value: ({name, account_manager_name}) => `${name} / ${account_manager_name}`,
            flexGrow: 3,
            minWidth: 150,
            align: 'center'
        },
        {
            id: 'email',
            label: 'Email',
            value: ({contact_email_list}) => contact_email_list && contact_email_list.length
                ? contact_email_list[0]
                : '',
            flexGrow: 3,
            minWidth: 150,
            align: 'center'
        },
        {
            id: 'ready_for_payment',
            label: 'Paid',
            value: ({available_for_payment}) => available_for_payment || 0,
            flexGrow: 2,
            minWidth: 80,
            align: 'center'
        },
        {
            id: 'currency',
            label: 'Currency',
            dataKey: 'currency',
            flexGrow: 2,
            minWidth: 80,
            align: 'center'
        },
    ];

    let amountUsd = 0;
    let amountEur = 0;
    for (const account of data) {
        if (!account.available_for_payment)
            continue;
            
        switch (account.currency_name) {
            case 'EUR':
                amountEur += account.available_for_payment;
                continue;
            default:
                amountUsd += account.available_for_payment;
        }
    }

    const savePaymentsReport = () => {
        const txt = [`Name;Email;Paid;Currency`];
        for (const item of data) {
            const email = item.contact_email_list && item.contact_email_list.length
                ? item.contact_email_list[0]
                : '';
            txt.push(`${item.name}/${item.account_manager_name};${email};${item.available_for_payment || 0};${item.currency}`);
        }
        saveFileBlob(txt.join("\n"), "payments.csv");
    };

    return (
        <Modal
            {...{show, onClose}}
            onClose={() => {
                onClose(false);
            }}
            title="Request Hawala Payments"
            width={resizedWidth > maxWidth ? maxWidth : resizedWidth}
            footer={false}
            successText="Confirm"
        >
            <p 
                style={{
                    paddingBottom: '20px',
                    textAlign: 'center'
                }}
            >
                <b>{data.length}</b> {`payments to Havala on amount ${amountUsd.toFixed(2)} USD and ${amountEur.toFixed(2)} EUR were created`}
            </p>

            <Table
                extraHeight={250}
                data={data}
                columns={columns}
            />

            <div style={{textAlign: 'center', paddingTop: '20px'}}>
                <ButtonPrimary
                    onClick={savePaymentsReport}
                >
                    Download
                </ButtonPrimary>
            </div>
        </Modal>
    )
}